module.exports = __webpack_public_path__ + "media/icons/copy-1396ea97.png";